import { render, staticRenderFns } from "./AccesosDashboard.vue?vue&type=template&id=a5cb5ccc&scoped=true"
import script from "./AccesosDashboard.vue?vue&type=script&lang=js"
export * from "./AccesosDashboard.vue?vue&type=script&lang=js"
import style0 from "./AccesosDashboard.vue?vue&type=style&index=0&id=a5cb5ccc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5cb5ccc",
  null
  
)

export default component.exports